window.submitIubendaForm = function(j_form){
  subject_id = j_form.find("input[data-cons-id]").val();
  _iub.cons.submit({
    form: { selector: j_form[0] },
    consent: {
      subject: {
        id: subject_id
      },
      legal_notices: [
        {
          "identifier": "privacy_policy",
          "version": "2"
        }
      ]
    }
  }).success(function(response){
    // callback success
    console.log('Success iubenda');
    console.log(arguments);
    $.ajax({
      url: '/wp-content/plugins/request_api_demo.php',
      type: 'POST',
      data: {
        api_url: window.demo_url+"api/iubenda/update_subject",
        email: subject_id,
        email_confirmation: ''
      },
      complete: function(){
        console.log(arguments);
      }
    });
  }).error(function(response){
    // callback error
    console.log('Error iubenda');
    console.log(arguments);
  });
}

var loadingScroll, urlScroll;
jQuery(document).ready(function($){
  var current_ajax_container;

  $.ajaxSetup({ cache: false });
  jQuery(document).on("click","a[data-remote=true]", function(event){
    event.preventDefault();
    var link=jQuery(this);
    current_ajax_container = link.data().container;
    ajaxHTML5(link.attr("href"), current_ajax_container, false);
  });

  History.Adapter.bind(window,'statechange',function(){
    var State = History.getState();
    if(State)
      ajaxHTML5(State.url, current_ajax_container, true);
  });

  if(jQuery('[data-autoscroll=true]').length > 0 && urlScroll != jQuery('#articles_next_link').attr('href') && window.location.pathname != urlScroll){
    loadingScroll = false;
    jQuery(window).scroll(function(){
      var next_link = jQuery('#articles_next_link');
      urlScroll = next_link.length>0 ? next_link.attr('href') : false;
      if(loadingScroll === false){
        if(urlScroll){
          var pagination_menu = jQuery('[data-autoscroll=true]');
          loadingScroll = true;
          jQuery.ajax({
            url: urlScroll,
            timeout: 60000,
            beforeSend: function(){
              pagination_menu.html(loading());
            },
            complete: function(xhr){
              pagination_menu.replaceWith(xhr.responseText);
              refreshAddThis();
              loadingScroll = false;
            }
          });
        }else{
          jQuery('[data-autoscroll=true]').replaceWith('');
        }
      }
    });
  }

  var seconda_immagine_post_2_foto_destra = jQuery("#seconda-immagine-post-2-foto-destra");
  if(seconda_immagine_post_2_foto_destra.length){
      var second_image = seconda_immagine_post_2_foto_destra.position().top;
      var height = seconda_immagine_post_2_foto_destra.height;
      var width = seconda_immagine_post_2_foto_destra.width;
      var width_content = seconda_immagine_post_2_foto_destra.data().width_content;
      jQuery(".single-page .desc ul").each(function(){
          var tag_ul=jQuery(this);
          if(tag_ul.position().top >= second_image && tag_ul.position().top <= (second_image+5+height)){
              tag_ul.wrap('<div class="floatleft" style="width:'+(width_content-width-10)+'px">');
          }
      });
  }

  var map_wrapper = jQuery('#map_wrapper');
  if(map_wrapper.length > 0){
    directionsService = new google.maps.DirectionsService();
    if(map_wrapper.data('lat') && map_wrapper.data('lng')){
      latlong = {
        lat: function(){return map_wrapper.data('lat');},
        lng: function(){return map_wrapper.data('lng');}
      };
      initialize(latlong);
    }
    else{
      getLatLong([map_wrapper.data().address,map_wrapper.data().approx], initialize);
    }

    jQuery('#get-directions-submit').on("click",function(){
      calcRoute();
    });
  }

  toggle_default_text('[data-default_value]');
  AutoRemoveDefaultValueOnSubmit('form');

  var data_video_autoload = jQuery('[data-video-autoload=true]');
  if(data_video_autoload.length > 0){
    video_media_js(data_video_autoload);
  }

  inizializeZclip();

  var menu = jQuery('.sf-menu');
  if(menu.length > 0){
    setTimeout(function(){
      menu.find(".children").hide();
    }, 1);
    menu.find('.page_item').hover(function(){
      var list_item = jQuery(this);
      list_item.addClass("sfHover");
      if(!menu.hasClass('mobile')){
        var sottomenu = list_item.children('ul');
        if(sottomenu.length > 0) {
          sottomenu.css({
            'visibility': 'visible',
            'display': 'block'
          });
          if(jQuery(this).data().resized !== true){
            list_item.data('resized',true);
            var new_sottomenu_height = 0;
            var max_sottomenu_height = Math.ceil(($(window).height() / 1.5) - sottomenu.position().top - list_item.position().top);
            var replace_lat_item = false;
            sottomenu.children('li').each(function(i){
              var row_height = jQuery(this).height() + parseInt(jQuery(this).css('borderBottomWidth')) + parseInt(jQuery(this).css('borderTopWidth'));
              if((max_sottomenu_height - new_sottomenu_height - row_height) > 0)
                new_sottomenu_height += row_height;
              else{
                jQuery(this).remove();
                replace_lat_item = true;
              }
            });
            if(replace_lat_item){
              var page_name = sottomenu.prev().attr('href').match(/\/\/[^\/]+\/(.*)$/);
              var showall = menu.data().viewall ? menu.data().viewall : 'vedi tutti...';
              sottomenu.children('li').last().html('<a href="/menu/'+page_name[1]+'">'+showall+'</a>');
            }
          }
        }
      }
    }, function(){
      if(!menu.hasClass('mobile')){
        if(!jQuery(this).parent().hasClass("children")){
          menu.find(".children").hide();
          menu.find(".sfHover").removeClass("sfHover");
        } else {
          jQuery(this).parent().find(".children").hide();
          jQuery(this).parent().find(".sfHover").removeClass("sfHover");
        }
      } else {
        if(!jQuery(this).parent().hasClass("children")){
          menu.find(".sfHover").removeClass("sfHover");
        } else {
          jQuery(this).parent().find(".sfHover").removeClass("sfHover");
        }
      }
    });
  }

  var crop_menu = jQuery('[data-crop_menu]');
  if(crop_menu.length > 0){
    crop_menu.children('.page_item').each(function(){
      var sottomenu = jQuery(this).children('ul');
      if(sottomenu.length == 0) return;

      var new_sottomenu_height = 0;

      sottomenu.css({
        'visibility': 'visible',
        'display': 'block'
      });
      var max_sottomenu_height = ($(window).height() / 5);
      var replace_lat_item = false;

      sottomenu.children('li').each(function(i){
        var row_height = jQuery(this).height() + parseInt(jQuery(this).css('borderBottomWidth')) + parseInt(jQuery(this).css('borderTopWidth'));
        if((max_sottomenu_height - new_sottomenu_height - row_height) > 0)
          new_sottomenu_height += row_height;
        else{
          jQuery(this).remove();
          replace_lat_item = true;
        }
      });
      if(replace_lat_item){
        var page_name = sottomenu.prev().attr('href').match(/\/\/[^\/]+\/(.*)$/);
        var showall = menu.data().viewall ? menu.data().viewall : 'vedi tutti...';
        sottomenu.children('li').last().html('<a href="/menu/'+page_name[1]+'">'+showall+'</a>');
      }
    });
  }

  // TODO: Sistemare per far aprire anche i video
  var fancybox = jQuery('.fancybox');
  if(fancybox.length > 0){
    $(".fancybox").each(function(){
      if($(this).hasClass("video")){
        $(this).fancybox({
          'padding': 10,
          'overlayColor': '#000',
          'overlayOpacity': 0.7,
          'autoPlay': false,
          'helpers': {
            'media': {}
          }
        });
      } else {
        $(this).fancybox({
          'padding': 10,
          'overlayColor': '#000',
          'overlayOpacity': 0.7
        });
      }
    });
  }

  var populate_search_option_list = jQuery('[data-populate-search-option-list]');
  if(populate_search_option_list.length > 0){
    $.getJSON('/wp-content/themes/StartTheme3.0/ajax-search-options-list.php',{s_id: s_id, type: populate_search_option_list.data('gallery-type')}, function(i){
      if(Object.keys(i.months).length > 0){
        $.each( i.months, function( key, value ) {
          populate_search_option_list.find('[data-months]').append('<option value="' + key + '">' + value + '</option>');
        });
      }else{
        var months_id = populate_search_option_list.find('[data-months]').attr('id');
        populate_search_option_list.find('[data-months]').hide();
        $('[for='+months_id+']').hide();
      }

      if(Object.keys(i.years).length > 0){
        $.each( i.years, function( key, value ) {
          populate_search_option_list.find('[data-years]').append('<option value="' + key + '">' + value + '</option>');
        });
      }else{
        var years_id = populate_search_option_list.find('[data-years]').attr('id');
        populate_search_option_list.find('[data-years]').hide();
        $('[for='+years_id+']').hide();
      }

      if(Object.keys(i.categories).length > 0){
        $.each( i.categories, function( key, value ) {
          populate_search_option_list.find('[data-categories]').append('<option value="' + key + '">' + value + '</option>');
        });
      }else{
        var categories_id = populate_search_option_list.find('[data-categories]').attr('id');
        populate_search_option_list.find('[data-categories]').hide();
        $('[for='+categories_id+']').hide();
      }

      if(Object.keys(i.authors).length > 0){
        $.each( i.authors, function( key, value ) {
          populate_search_option_list.find('[data-authors]').append('<option value="' + key + '">' + value + '</option>');
        });
      }else{
        var authors_id = populate_search_option_list.find('[data-authors]').attr('id');
        populate_search_option_list.find('[data-authors]').hide();
        $('[for='+authors_id+']').hide();
      }

      if(Object.keys(i.competitions).length > 0){
        $.each( i.competitions, function( key, value ) {
          populate_search_option_list.find('[data-competitions]').append('<option value="' + key + '">' + value + '</option>');
        });
      }else{
        var competitions_id = populate_search_option_list.find('[data-competitions]').attr('id');
        populate_search_option_list.find('[data-competitions]').hide();
        $('[for='+competitions_id+']').hide();
      }

    });
  }

  $(document).on('submit', 'form[data-remote=true]', function(event) {
    var form = $(this);
    event.preventDefault();
    var message_error = form.data('message-error');
    var message_success = form.data('message-success');
    var error = false;
    form.find("[required]").each(function(){
      if($(this).attr('type') == 'checkbox'){
        if(!$(this).is(':checked')) error = true;
      } else if($(this).val()==""){
        error = true;
      }
    });
    if(form.find("input[data-empty='true']").length>0){
      if(form.find("input[data-empty='true']").val()!="")
        error = true;
    }
    if(error){
      alert(message_error);
    } else {
      var message_confirm = form.data('confirm');
      if(!message_confirm || confirm(message_confirm)){
        if(form.hasClass('newsletter-form')){
          ov = $('<div id="overlay-newsletter">').appendTo('body');
          data = form.serialize()+"&api_url="+form.attr('action');
          _callback = form.data().callback ? form.data().callback : false;
          $.ajax({
            url: "/wp-content/plugins/request_api_newsletter.php",
            type: 'POST',
            data: data,
            complete: function(){
              if(!_callback || !window[_callback]) ov.remove();
            },
            success: function(response, status, xhr){
              if(form.hasClass('iubenda')) submitIubendaForm(form);
              setTimeout(function(){
                form.find("input[type=text],input[type=email],textarea,select").val("");
                form.find("input[type=text],input[type=email],textarea,select").attr("value", "");
                form.find("input[type=checkbox]").prop("checked", false);
              }, 500);
              if(_callback && window[_callback]){
                _args = form.data().callbackArgs ? form.data().callbackArgs : '';
                window[_callback](_args);
              } else {
                alert(message_success);
              }
            },
            error: function(xhr, status, error){
              console.log(arguments);
              alert(message_error);
            }
          });
        } else {
          $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            dataType: 'json',
            data: form.serialize(),
            success: function( data ) {
              alert(message_success);
              setTimeout(function(){
                form.find("input[type=text],input[type=email],textarea").val("")
                form.find("input[type=text],input[type=email],textarea").attr("value","")
              }, 500);
            },
            error: function( xhr, err ) {
              alert(message_error);
            }
          });
        }
      }
    }
  });

  data_resize_and_center();
  data_center_image();

  // Push azioni per google analytics
  $('.staff_signup_link').on('click', function(){
    // if(typeof _gaq != 'undefined')
    _gaq.push(['_trackEvent', 'Iscrizione Staff', 'iscrizione', '0']);
  });

  $('.athlete_signup_link').on('click', function(){
    // if(typeof _gaq != 'undefined')
    _gaq.push(['_trackEvent', 'Iscrizione Staff', 'iscrizione', '0']);
  });

  $('.login_link').on('click', function(){
    // if(typeof _gaq != 'undefined')
    _gaq.push(['_trackEvent', 'login', 'login', '0']);
  });

  window.params_get = {}
  if(window.location.search != ""){
    var string_params_get = window.location.search.replace("?","");
    if(string_params_get.match(/&/)) string_params_get = string_params_get.replace(/&/g,"=");
    var split_params_get = string_params_get.split("=");
    $.each(split_params_get, function(i,param){
      if(!((i/2)+"").match(/\./) || (i/2)==0)
        window.params_get[param] = split_params_get[i+1]
      else
        return
    });
  }

});
